import { Component, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import { ArticleService } from '../../article/article.service';
import { ISubscription } from "rxjs/Subscription";
import { NavService } from '../../header/nav/nav.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BreadcrumbService } from '../../header/breadcrumb/breadcrumb.service';
import { TopnavService } from '../../header/topnav/topnav.service';

import 'rxjs/add/operator/switchMap';
import { SharedService } from '../../common/shared.service';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: May 28 2018
 * 
 * Description: Component class for Archive Content - archive/content/:id
 **/
@Component({
  selector: 'gosg-archivecontent',
  templateUrl: './archivecontent.component.html',
  styleUrls: ['./archivecontent.component.css']
})
export class ArchivecontentComponent implements OnInit, AfterViewInit, OnDestroy {
  statusID: any;
  @Output() menuClick = new EventEmitter();
  breadcrumb: any;
  isValid: any;
  topicID: number;
  subID: number;
  moduleName: string;
  articles: any[];
  lang;
  langId;

  private subscriptionLang: ISubscription;

  articleData: any;
  @Output() langChange = new EventEmitter();

  handleClickMe(e){

  }

  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };


  constructor(private sharedService: SharedService, public articleService: ArticleService,  private route: ActivatedRoute,
    private navService: NavService, private translate: TranslateService, private router: Router,
    private topnavservice: TopnavService,
    private breadcrumbService: BreadcrumbService) {
    this.lang = translate.currentLang;
    this.langId = 1;

        this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {

        const myLang = translate.currentLang;

        if (myLang == 'en') {

            translate.get('HOME').subscribe((res: any) => {
                this.lang = 'en';
                this.langId = 1;
                this.moduleName = this.router.url.split('/')[2];
                this.topicID = parseInt(this.router.url.split('/')[3]);
                var tt = this.router.url.split('/');
                // this.subID = parseInt(tt[tt.length-1]);
                this.subID = parseInt(this.router.url.split('/')[4]);
            });

        }
        if (myLang == 'ms') {

            translate.get('HOME').subscribe((res: any) => {
                this.lang = 'ms';
                this.langId = 2;
                this.moduleName = this.router.url.split('/')[2];
                this.topicID = parseInt(this.router.url.split('/')[3]);
                var tt = this.router.url.split('/');
                // this.subID = parseInt(tt[tt.length-1]);
                this.subID = parseInt(this.router.url.split('/')[4]);
            });
        }

        if(this.topnavservice.flagLang){

          if(this.moduleName == 'subcategory'){
            this.navService.triggerSubArticleOther(this.subID, this.langId, 'archive','noaudit');
          }else if(this.moduleName == 'content'){
            this.navService.triggerContentOther(this.topicID, this.langId, 'archive', 'noaudit');
          }else{
            this.navService.triggerArticle(this.moduleName,  this.langId, this.topicID, 'noaudit');
          }
        }

      });

      this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
        this.fontSize = data;
      });
   }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    //this.subscription.unsubscribe();
  }

  ngOnInit() {

    if(!this.langId){
      if (localStorage.getItem('langID')) {
        this.langId = localStorage.getItem('langID');
      } else {
        this.langId = 1;
      }
    }else{
      this.langId = 1;
    }

    this.articleData = this.articleService.getArticle();
    this.topicID = parseInt(this.router.url.split('/')[3]);
    var tt = this.router.url.split('/');
    this.subID = parseInt(tt[tt.length-1]);
    this.navService.triggerContentOther(this.topicID, localStorage.getItem('langID'), 'archive');
  }

  ngAfterViewInit() {
    // Sent to GA
    setTimeout(() => {
      window.scrollTo(0, 0);
      setTimeout(() => {
          this.sharedService.sentToGtag();
      }, 500);
    }, 500);  

    this.sharedService.loadFontSizeData();
  }


  getTheme(){
    return localStorage.getItem('themeColor');
  }

  clickSideMenu(e, status, url){
    this.navService.loader = true;
    this.statusID = status;
    // this.navService.getSubArticleUrlOthers( e.categoryId, localStorage.getItem('langID'), 'archive');
    // this.navService.triggerSubArticleOther(e.categoryCode, localStorage.getItem('langID'), 'archive');
    this.router.navigate( ['/archive/subcategory', e.categoryCode]);
    event.preventDefault();
  }


  clickSideMenuSubCategory(e, status, url){
    this.navService.loader = true;
    this.statusID = status;
    // this.navService.getSubArticleUrlOthers(e, localStorage.getItem('langID'), url);
    // this.navService.triggerSubArticleOther(e, localStorage.getItem('langID'), url);
    this.router.navigate(['/archive/subcategory', e]);
    event.preventDefault();
  }


  clickContentFromMenu(pId, aId, status, url){
    this.navService.loader = true;
    this.statusID = status;
    // this.navService.triggerContentOther(aId, localStorage.getItem('langID'), url);
    // this.navService.getContentUrlOther( aId, localStorage.getItem('langID'), url);
    this.router.navigate( ['/archive/content', aId]);
    event.preventDefault();
  }

  getModule(data){
    let a = data.split("/");
    return a[1];
  }

  getID(data){
    let a = data.split("/");
    return a[2];
  }

  breadcrumLink(id1, id2, $event){

    if(this.getModule(id1) === 'category'){
      this.router.navigate(['/archive/category', this.getID(id2)]);
    }else if(this.getModule(id1) === 'subcategory'){
      this.router.navigate(['/archive/subcategory', this.getID(id2)]);
      // this.navService.getSubArticleUrlOthers(this.getID(id2), localStorage.getItem('langID'), 'archive');
      // this.navService.triggerSubArticleOther(this.getID(id2), localStorage.getItem('langID'), 'archive');
    }
    $event.preventDefault();
  }

  checkImgData(e){
      const chkData = e.search('<img');
      if (chkData != -1){
          return true;
      }else{
          return false;
      }
  }

}




// WEBPACK FOOTER //
// ./src/app/archive/archivecontent/archivecontent.component.ts